// rootReducer.js
import { combineReducers } from "redux";
import userDetailsReducer from "../features/userDetailsSlice";
import calendarWidgetReducer from "../features/calendarWidgetSlice";
import timeSlotWidgetReducer from "../features/timeSlotWidgetSlice";
import consultationModeWidgetReducer from "../features/consultationModeWidgetSlice";
import serviceForReducer from "../features/serviceForSlice";
import patientRegistrationReducer from "../features/patientRegistrationSlice";

const rootReducer = combineReducers({
  userDetails: userDetailsReducer,
  calendarWidget: calendarWidgetReducer,
  timeSlotWidget: timeSlotWidgetReducer,
  consultationModeWidget: consultationModeWidgetReducer,
  serviceFor: serviceForReducer,
  patientRegister: patientRegistrationReducer,
});

export default rootReducer;
